import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SettingsService } from '../../services/setting-service/setting.service';
import { ProductService } from './../../services/product-service/product.service';
import { ProductEdit } from './product-edit/product-edit';
import { ProductRegister } from './product-register/product-register';
import { Editor } from 'ngx-editor';

@Component({
    selector: 'app-products',
    standalone: false,
    templateUrl: './products.html',
    styleUrl: './products.scss',
})
export class Products implements OnInit {
    kits: any = [];
    loading: boolean = false;
    viewEditors: Editor[] = [];
    expandedCards: boolean[] = []; // Controla expansão de cada card


    constructor(private productService: ProductService,
        public settingsService: SettingsService,
        private dialog: MatDialog

    ) {
        this.settingsService.title = 'Produtos';
    }

    async ngOnInit() {
        this.loading = true;
        let cpf = this.settingsService.user.cpf;
        const result = await this.productService.getKits(cpf);
        this.kits = Array.isArray(result) ? result : [];
        this.viewEditors = this.kits.map(() => new Editor());
        this.expandedCards = this.kits.map(() => false); // Inicia todos como não expandidos
        this.loading = false;
    }
   ngOnDestroy(): void {
    this.viewEditors.forEach(editor => editor.destroy());
  }

  // Método para alternar expansão do card
  toggleExpand(index: number): void {
    this.expandedCards[index] = !this.expandedCards[index];
  }

    editOrCreate(enterAnimationDuration: string, exitAnimationDuration: string, kit: any, action: string): void {
        let dialogRef
        if (action == 'edit') {
            dialogRef = this.dialog.open(ProductEdit, {
                width: '60vw',
                maxWidth: '60vw',
                maxHeight: '90vh',
                height: '90vh',
                enterAnimationDuration,
                exitAnimationDuration,
                data: {
                    kit: kit,
                },
            });
        } else {
            dialogRef = this.dialog.open(ProductRegister, {
                width: '60vw',
                maxWidth: '60vw',
                maxHeight: '90vh',
                height: '90vh',
                enterAnimationDuration,
                exitAnimationDuration,
            });
        }

        dialogRef.afterClosed().subscribe(async () => {
              this.loading = true;
              const res = await this.productService.getKits(this.settingsService.user.cpf);
              this.kits = Array.isArray(res) ? res : [];
              this.loading = false;
        });
    }

    async toggleProductStatus(kit: any) {
        const action = kit.status ? 'inativar' : 'ativar';
        const confirmMessage = `Tem certeza que deseja ${action} o kit "${kit.titulo || kit.subtitulo}"?`;
        
        if (!confirm(confirmMessage)) {
            return;
        }

        this.loading = true;
        try {
            const payload = {
                ...kit,
                status: !kit.status
            };

            await this.productService.updateKit(payload);
            const r = await this.productService.getKits(this.settingsService.user.cpf);
            this.kits = Array.isArray(r) ? r : [];
            
        } catch (error) {
            console.error(`Erro ao ${action} kit:`, error);
            alert(`Erro ao ${action} kit. Tente novamente.`);
        } finally {
            this.loading = false;
        }
    }
}
